<template>
  <b-tab :title="$store.state.localization.data.mainPage.driversLabel">
    <b-form-group
      label-cols-sm="7"
      label-cols-lg="7"
      content-cols-sm
      content-cols-lg="7"
      :label="$store.state.localization.data.mainPage.userSettings.displayedColumnsLabel"
      label-for="input-horizontal"
    >
    </b-form-group>
    <div
        class="row no-gutters"
        style="margin-left: 5px; margin-bottom: 5px"
        >
          <div class="col-11">
            <b-form-select
              v-model="displayedColumns.data"
              :options="displayedColumns.values"
              multiple
              :select-size="13"
              style="font-size: 13px"
            ></b-form-select>
          </div>
    
        <div class="col-1 align-self-center" style="text-align: center">
          <b-button-group vertical>
            <b-button
              size="sm"
              style="font-size: 12px; width: 32px"
              variant="success"
              @click="upColumns"
              >+</b-button
            >
            <b-button
              size="sm"
              style="font-size: 12px"
              variant="success"
              @click="downColumns"
              >-</b-button
            >
          </b-button-group>
        </div>
    </div>
  </b-tab>
</template>

<script>
import { userService } from "../../../services";

export default {
  name: "DriversTab",
  data() {
    return {
      displayedColumns: {
        data: [],
        values: [],
      },
      hideSummary: false
    };
  },
  created() {
    const displayedColumnsSetting =
      this.$store.state.authentication.userSettings.find((x) => {
        return x.settingName == userService.DRIVERS_TABLE_DISPLAYED_COLUMNS;
      });

    if (displayedColumnsSetting) {
      const displayedColumns = JSON.parse(displayedColumnsSetting.settingValue);

      if (displayedColumns) {
        for (let i = 0; i < displayedColumns.length; i++) {
          this.displayedColumns.values.push({
            value: displayedColumns[i].name,
            text: this.$store.state.localization.data.mainPage.drivers
              .tableColumns[displayedColumns[i].name]
          });
          this.displayedColumns.data.push(displayedColumns[i].name);
        }
        for (const key of Object.keys(
          this.$store.state.localization.data.mainPage.drivers.tableColumns)) {
          const item = displayedColumns.find(x => x.name == key);
          if (!item) {
            this.displayedColumns.values.push({
              value: key,
              text: this.$store.state.localization.data.mainPage.drivers
                .tableColumns[key],
            });
          }
        }
        return;
      } 
    }

    for (const key of Object.keys(
     this.$store.state.localization.data.mainPage.drivers.tableColumns)) {
     this.displayedColumns.values.push({
       value: key,
       text: this.$store.state.localization.data.mainPage.drivers
         .tableColumns[key],
     });
     this.displayedColumns.data.push(key);
    }
  },
  methods: {
    getDisplayedColumns() {
      const displayedColumns = [];

      for (let i = 0; i < this.displayedColumns.data.length; i++) {
        displayedColumns.push({
          name: this.displayedColumns.data[i]
        });
      }

      return displayedColumns;
    },
    upColumns() {
      const newValues = [];

      for (let i = 0; i < this.displayedColumns.values.length; i++) {
        const columnIndex = this.displayedColumns.data.indexOf(
          this.displayedColumns.values[i].value
        );

        if (columnIndex != -1 && i != 0) {
          const oldValue = newValues[i - 1];
          newValues[i - 1] = this.displayedColumns.values[i];
          newValues[i] = oldValue;
        } else {
          newValues.push(this.displayedColumns.values[i]);
        }
      }

      this.displayedColumns.values = newValues;
    },
    downColumns() {
      const newValues = new Array(this.displayedColumns.values.length);

      for (let i = this.displayedColumns.values.length - 1; i >= 0; i--) {
        const columnIndex = this.displayedColumns.data.indexOf(
          this.displayedColumns.values[i].value
        );

        if (
          columnIndex != -1 &&
          i != this.displayedColumns.values.length - 1
        ) {
          const oldValue = newValues[i + 1];
          newValues[i + 1] = this.displayedColumns.values[i];
          newValues[i] = oldValue;
        } else {
          newValues[i] = this.displayedColumns.values[i];
        }
      }

      this.displayedColumns.values = newValues;
    },
  },
};
</script>
